import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MathService {

  constructor() { }

  public RoundUp (num: number, places: number = 2) {
    var scale = Math.pow(10, places);
    return Math.ceil(num * scale)/scale;
  }

  public GetScheduleStatus (dateFrom, dateTo, dateToday) : string {
      var _dateFrom = new Date(dateFrom);
      var _dateTo = new Date(dateTo);

      var dateToCheck = new Date(dateToday).getTime();
      
      if(dateToCheck < _dateFrom.getTime()) { return "Scheduled" }
      else if(dateToCheck > _dateFrom.getTime() && dateToCheck < _dateTo.getTime()) { return "Active" }
      else { return "Expired" }
  }

  public FormattedScheduleStatus (dateFrom, dateTo, dateToday) : string {
      var _dateFrom = new Date(dateFrom);
      var _dateTo = new Date(dateTo);
      var _dateFromStr =_dateFrom.toDateString().substring(4);
      var _dateToStr =_dateTo.toDateString().substring(4);

      var dateToCheck = new Date(dateToday).getTime();
      var _schedStatus = "";
      if(dateToCheck < _dateFrom.getTime()) { _schedStatus = "Scheduled" }
      else if(dateToCheck > _dateFrom.getTime() && dateToCheck < _dateTo.getTime()) { _schedStatus = "Active" }
      else { _schedStatus = "Expired" }
      
      return _schedStatus + "||Start: " + _dateFromStr + "||End: " + _dateToStr;
  }
}
